import React from "react";
import { IonContent, IonPage } from "@ionic/react";
import { useBLE } from "../../../hooks/useBle";
import Header from "../../../components/Header";
import { useIonRouter } from "@ionic/react";

const BiWazeDeviceDetail: React.FC = () => {
  const { device, serialNumber, deviceType, openModal, deviceVersion } =
    useBLE();

  const handleDisconnect = () => {
    if (device) openModal("disconnect", device);
  };

  const router = useIonRouter();

  return (
    <IonPage
      className="remote-page"
      style={{
        "--ion-background-color": "#000000",
        "--ion-text-color": "#ffffff",
      }}
    >
      <Header
        showGreeting={false}
        showPageTitle={true}
        showUserIcon={false}
        pageTitle={deviceType.includes("Cough") ? deviceType : "BiWaze® Clear"}
        showBackButton={true}
        onBackButtonClick={() => router.push("/remote/scan", "back", "replace")}
      />

      <IonContent
        // className="ion-padding"
        style={{
          "--background": "#000000",
          "--padding-top": "0px",
        }}
      >
        <div
          style={{
            fontFamily:
              "Figtree, -apple-system, BlinkMacSystemFont, sans-serif",
            color: "#ffffff",
            paddingTop: "20px",
          }}
        >
          {/* About Section */}
          <div style={{ marginBottom: "32px" }}>
            <h2
              style={{
                color: "#8E8E93",
                fontSize: "13px",
                fontWeight: "400",
                letterSpacing: "0.5px",
                textTransform: "uppercase",
                marginBottom: "16px",
                paddingLeft: "4px",
              }}
            >
              ABOUT
            </h2>

            {/* Device Info Card */}
            <div
              style={{
                backgroundColor: "#1C1C1E",
                borderRadius: "12px",
                overflow: "hidden",
              }}
            >
              {/* Name Row */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "16px 20px",
                  borderBottom: "0.5px solid rgba(255, 255, 255, 0.1)",
                }}
              >
                <span
                  style={{
                    color: "#ffffff",
                    fontSize: "17px",
                    fontWeight: "400",
                  }}
                >
                  Name
                </span>
                <span
                  style={{
                    color: "#8E8E93",
                    fontSize: "17px",
                    fontWeight: "400",
                  }}
                >
                  {deviceType.includes("Cough") ? deviceType : "BiWaze® Clear"}
                </span>
              </div>

              {/* Serial Number Row */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "16px 20px",
                  borderBottom: "0.5px solid rgba(255, 255, 255, 0.1)",
                }}
              >
                <span
                  style={{
                    color: "#ffffff",
                    fontSize: "17px",
                    fontWeight: "400",
                  }}
                >
                  Serial Number
                </span>
                <span
                  style={{
                    color: "#8E8E93",
                    fontSize: "17px",
                    fontWeight: "400",
                    fontFamily: "SF Mono, Monaco, monospace",
                  }}
                >
                  {serialNumber || "Unknown"}
                </span>
              </div>

              {/* Version Row */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "16px 20px",
                }}
              >
                <span
                  style={{
                    color: "#ffffff",
                    fontSize: "17px",
                    fontWeight: "400",
                  }}
                >
                  Version
                </span>
                <span
                  style={{
                    color: "#8E8E93",
                    fontSize: "17px",
                    fontWeight: "400",
                  }}
                >
                  {deviceVersion || "Unknown"}
                </span>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div
            style={{ display: "flex", flexDirection: "column", gap: "12px" }}
          >
            {/* Forget Device Button */}
            {/* <button
              style={{
                width: '100%',
                backgroundColor: '#1C1C1E',
                border: 'none',
                borderRadius: '12px',
                padding: '16px 20px',
                textAlign: 'left',
                fontSize: '17px',
                fontWeight: '400',
                color: '#0A84FF',
                fontFamily: 'Figtree, -apple-system, BlinkMacSystemFont, sans-serif',
                cursor: 'pointer',
                transition: 'opacity 0.2s',
              }}
              onClick={handleForgetDevice}
              onMouseDown={(e) => e.currentTarget.style.opacity = '0.7'}
              onMouseUp={(e) => e.currentTarget.style.opacity = '1'}
              onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
            >
              Forget device
            </button> */}

            {/* Disconnect Button */}
            <button
              style={{
                width: "100%",
                backgroundColor: "#1C1C1E",
                border: "none",
                borderRadius: "12px",
                padding: "16px 20px",
                textAlign: "left",
                fontSize: "17px",
                fontWeight: "400",
                color: "#0A84FF",
                fontFamily:
                  "Figtree, -apple-system, BlinkMacSystemFont, sans-serif",
                cursor: "pointer",
                transition: "opacity 0.2s",
              }}
              onClick={handleDisconnect}
              onMouseDown={(e) => (e.currentTarget.style.opacity = "0.7")}
              onMouseUp={(e) => (e.currentTarget.style.opacity = "1")}
              onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
            >
              Disconnect
            </button>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default BiWazeDeviceDetail;
